import { axiosInstance as request } from '@api/rest.service'

const api = '/users'

/**
 * @description GET /users/create
 * @returns {AxiosPromise<any>}
 */
export const GET_USERS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /users/current
 * @returns {AxiosPromise<any>}
 */
export const GET_CURRENT_USER = () => request.get(`${api}/current`)

/**
 * @description GET /users
 * @returns {AxiosPromise<any>}
 */
export const GET_USERS = () => request.get(api)

/**
 * @description POST /users
 * @returns {AxiosPromise<any>}
 */
export const CREATE_USER = payload => request.post(api, payload)

/**
 * @description PUT /users/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_USER = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description PUT /users/{param}/change-password
 * @returns {AxiosPromise<any>}
 */
export const CHANGE_USER_PASSWORD = (userId, payload) => request.put(`${api}/${userId}/change-password`, payload)

/**
 * @description PUT /users/{id}/activate
 * @returns {AxiosPromise<any>}
 */
export const ACTIVATE_USER = id => request.put(`${api}/${id}/activate`)

/**
 * @description GET /users/{id}/deactivate-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_USER_DEACTIVATE_CONFIRMATION = id => request.get(`${api}/${id}/deactivate-confirmation`)

/**
 * @description PUT /users/{id}/deactivate?replace_with={id}
 * @returns {AxiosPromise<any>}
 */
export const DEACTIVATE_USER = (id, replacementId) => {
  const params = replacementId ? { replace_with: replacementId } : ''
  return request.put(`${api}/${id}/deactivate`, { params })
}

/**
 * @description PUT /users/{id}/google-account-email
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_GAE = (id, payload) => request.put(`${api}/${id}/google-account-email`, payload)

/**
 * @description PUT /users/{id}/resetPassword
 * @returns {AxiosPromise<any>}
 */
export const RESET_PASSWORD = id => request.put(`${api}/${id}/resetPassword`)

/**
 * @description GET /users/export
 * @returns {AxiosPromise<any>}
 */
export const EXPORT_USERS = () =>
  request.get(`${api}/export`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  })
